var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM8.77347 6.68687C8.96873 6.49163 8.96873 6.17504 8.77347 5.97978C8.5782 5.78452 8.2616 5.78452 8.0664 5.97978L5.75325 8.29287L4.94014 7.4798C4.74488 7.28453 4.4283 7.28453 4.23303 7.4798C4.03777 7.67507 4.03777 7.9916 4.23303 8.18687L5.3997 9.35353C5.59497 9.5488 5.91155 9.5488 6.10681 9.35353L8.77347 6.68687ZM11.7735 7.68687C11.9687 7.4916 11.9687 7.17507 11.7735 6.9798C11.5782 6.78453 11.2616 6.78453 11.0664 6.9798L8.75327 9.29287L8.44013 8.9798C8.24487 8.78453 7.92827 8.78453 7.73307 8.9798C7.5378 9.17507 7.5378 9.4916 7.73307 9.68687L8.39973 10.3535C8.59493 10.5488 8.91153 10.5488 9.1068 10.3535L11.7735 7.68687Z",
    fill: "#680DDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskFilled);
export default __webpack_public_path__ + "static/media/task_filled.a867edf76ea93d64e6ccd70493e5f9e5.svg";
export { ForwardRef as ReactComponent };